import { defineMessages } from "react-intl";
const messages = defineMessages({
    spaceEmbedCodeCopySuccess: {
        id: "app.spaces.actions.embedCode.copy.success.text",
        defaultMessage: "Code successfully copied to clipboard.",
    },
    spaceEmbedCodeTitle: {
        id: "app.spaces.actions.embedCode.title.text",
        defaultMessage: "Embed Code",
    },
    spaceEmbedCodeCopyButton: {
        id: "app.spaces.actions.embedCode.copy.button.text",
        defaultMessage: "Copy Embed Code",
    },
    spaceEmbedCodePreviewButton: {
        id: "app.spaces.actions.embedCode.preview.button.text",
        defaultMessage: "Preview Code",
    },
    spaceEmbedCodeFormLayoutSize: {
        id: "app.spaces.actions.embedCode.form.layoutSize.text",
        defaultMessage: "Layout Size",
    },
    spaceEmbedCodeFormDimensionWidth: {
        id: "app.spaces.actions.embedCode.form.dimensionWidth.text",
        defaultMessage: "Width",
    },
    spaceEmbedCodeFormDimensionHeight: {
        id: "app.spaces.actions.embedCode.form.dimensionHeight.text",
        defaultMessage: "Height",
    },
    spaceEmbedCodeFormShowListingDetails: {
        id: "app.spaces.actions.embedCode.form.showListingDetails.text",
        defaultMessage: "Listing Details",
    },
    spaceEmbedCodeFormShowRoomsMenu: {
        id: "app.spaces.actions.embedCode.form.showRoomsMenu.text",
        defaultMessage: "Rooms Menu",
    },
    spaceEmbedCodeFormToggleSwitchShow: {
        id: "app.spaces.actions.embedCode.form.toggleSwitchShow.text",
        defaultMessage: "Show",
    },
    spaceEmbedCodeFormToggleSwitchHide: {
        id: "app.spaces.actions.embedCode.form.toggleSwitchHide.text",
        defaultMessage: "Hide",
    },
});
export default messages;
